import changePassword from './changepassword';
import checkpwlink from './checkpwlink';
import resetpwemail from './resetpwemail';
import getuser from './getuser';
import setcustomeruser from './setcustomeruser';
import delcustomeruser from './delcustomeruser';
import getusers from './getusers';
import resetpw from './resetpw';
import find from './find';

export default {
  changePassword,
  checkpwlink,
  resetpwemail,
  getusers,
  getuser,
  setcustomeruser,
  delcustomeruser,
  resetpw,
  find,
};



// WEBPACK FOOTER //
// ./src/app/services/account/index.js